import { defineNuxtRouteMiddleware } from '#app';
import { useMenu } from '~/modules/menu/uses/useMenu';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { updateMenu, updateMenuCategories, updateProductCategories } = useMenu();

  await callOnce(async () => {
    await Promise.allSettled([
      updateMenu(),
      updateMenuCategories(),
      updateProductCategories(),
    ]);
  });
});
